import { render, staticRenderFns } from "./DocsInfos.vue?vue&type=template&id=3fb0183a&"
import script from "./DocsInfos.vue?vue&type=script&lang=js&"
export * from "./DocsInfos.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports